<button
  type="button"
  class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full border border-gray-200 text-gray-500 transition-colors hover:border-blue-200 hover:bg-blue-50 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:border-gray-600 dark:text-gray-300 dark:hover:border-blue-500/40 dark:hover:bg-blue-500/10 dark:hover:text-blue-300 dark:focus:ring-offset-gray-900"
  [attr.aria-label]="copied() ? copiedAriaLabel() : ariaLabel()"
  [attr.title]="copied() ? copiedTitle() : title()"
  (click)="copy()"
>
  @if (copied()) {
    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
    </svg>
  } @else {
    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="M8 7V5.75A1.75 1.75 0 019.75 4h7.5A1.75 1.75 0 0119 5.75v8.5A1.75 1.75 0 0117.25 16H16"
      />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="M6.75 8h7.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0114.25 20h-7.5A1.75 1.75 0 015 18.25v-8.5C5 8.784 5.784 8 6.75 8z"
      />
    </svg>
  }
</button>
